import * as React from "react";
import { Tooltip, withStyles } from "@material-ui/core";
import { Done as DoneIcon } from "@material-ui/icons";
import i18n from "i18n";
import { formatNumber } from "utils/MathUtils";

const lineStyle = {
  font: "normal normal normal 10px/26px Roboto",
  float: "left" as any,
  textAlign: "left" as any,
  overflow: "hidden",
  whiteSpace: "nowrap" as any,
  textOverflow: "ellipsis",
};

const styles = () => ({
  title: {
    margin: "15px 0",
    paddingLeft: 15,
    textAlign: "left" as any,
    font: "normal normal bold 9px/10px Raleway",
    letterSpacing: 0.9,
    color: "#FFFFFF99",
    opacity: 1,
    width: "99%",
  },
  itemContainer: {
    width: "99%",
    color: "white",
    height: 26,
    borderBottom: "1px solid #262527",
    background: "#2E2E2E 0% 0% no-repeat padding-box",
    "&:hover": {
      cursor: "pointer",
      background: "#464646",
    },
    "&:hover div": {
      opacity: 1,
    },
  },
  stageLine: {
    ...lineStyle,
    paddingLeft: 16,
    paddingRight: 5,
    width: "100%",
    color: "#E5E1E1",
  },
  lineDesc: {
    ...lineStyle,
    paddingRight: 8,
    width: "65%",
    color: "rgb(171, 171, 171)",
  },
  lineValue: {
    ...lineStyle,
    width: "25%",
    font: "10px / 26px Roboto",
    paddingRight: 8,
    color: "rgb(171, 171, 171)",
    textAlign: "right" as any,
  },
  buttonContainer: {
    width: "10%",
    height: "inherit",
    color: "rgb(171, 171, 171)",
    float: "left" as any,
    textAlign: "left" as any,
    lineHeight: "26px",
    opacity: 0,
  },
  icon: {
    fontSize: 15,
    height: 26,
  },
  emptyMessage: {
    padding: "5px 5px 5px 16px",
    width: "100%",
    font: "normal normal normal 10px/13px Roboto",
    color: "rgb(171, 171, 171)",
    lineHeight: "26px",
    textAlign: "left" as any,
    background: "#2E2E2E 0% 0% no-repeat padding-box",
  },
});

interface IProps {
  classes: any;
  takeOffFormatedList: any[];
  canInsertAtEAP: boolean;
  hasNoErrors: boolean;
  onLineClick: (line: any) => void;
}

const TakeOffList = ({
  classes,
  takeOffFormatedList = [],
  canInsertAtEAP = true,
  hasNoErrors = true,
  onLineClick = () => {},
}: IProps) => {
  const labels = i18n.modelMaps.menuLateral;

  return (
    <div>
      <div className={classes.title}>{labels.quantities}</div>
      {takeOffFormatedList.map((line) => {
        if (!line) return <></>;

        const qttFormated = formatNumber(line.resultQuantity);
        return (
          <div className={classes.itemContainer}>
            {line.isStage ? (
              <div className={classes.stageLine} title={line.description}>
                {line.description}
              </div>
            ) : (
              <>
                <div
                  className={classes.lineDesc}
                  title={line.description}
                  style={{
                    paddingLeft: line.parentIndex == -1 ? 16 : 26,
                  }}
                >
                  {line.description}
                </div>
                <div
                  className={classes.lineValue}
                  title={`${qttFormated} ${line.unit}`}
                >
                  {`${qttFormated} ${line.unit}`}
                </div>
                {canInsertAtEAP && (
                  <div className={classes.buttonContainer}>
                    <Tooltip style={{ cursor: "pointer" }} title={labels.add}>
                      <DoneIcon
                        className={classes.icon}
                        onClick={() => onLineClick(line)}
                      />
                    </Tooltip>
                  </div>
                )}
              </>
            )}
          </div>
        );
      })}
      {takeOffFormatedList.length === 0 && hasNoErrors && (
        <div className={classes.emptyMessage}>
          {labels.noFormatDefined}
          {labels.noFormatDefined2}
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(TakeOffList);



// WEBPACK FOOTER //
// ./src/modules/modelMap/components/layouts/ModelMapItem/TakeOffList.tsx